<template>
  <div class="app-container">
    <div class="header">
      <el-row :gutter="20">
        <el-col :xs="4" :sm="2" :md="2" :lg="1" :xl="1">
          <img src="/assets/img/icons/clock.png" style="width: 40px;">
        </el-col>
        <el-col :xs="20" :sm="22" :md="22" :lg="22" :xl="23" style="padding-top: 5px">
          <h4 class="title">
            <template v-if="timetableId !== ''">
              Control de asistencia
            </template>
            <template v-else>
              Horario
            </template>
          </h4>
        </el-col>
      </el-row>
    </div>
    <hr>
    <enrolment-form v-if="dialogVisible" :timetable_id="timetableId" :dialogVisible="dialogVisible" @dialogVisible="onDialogVisible" />
    <template v-if="timetableId === ''">
      <calendar :is_admin="is_admin" @timetableData="onTimetableData" :date_week="week" />
    </template>
    <template v-else>
      <div class="content">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
            <el-button type="info" @click="selectCalendarComponent()">
              <i class="el-icon-back"></i> Volver a vista de horarios
            </el-button>
          </el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
            <el-button v-if="is_admin" :disabled="timetable.course_is_full" type="primary" @click="openEnrolmentForm()">
              <i class="el-icon-s-order"></i> Nueva matrícula
            </el-button>
          </el-col>
        </el-row>
      </div>
      <students :isAdmin="is_admin" :timetable_id="timetableId" :date="date" :key="key" />
    </template>
  </div>
</template>
<script>
  import Calendar from './Calendar.vue';
  import Students from './Students/List.vue';
  import EnrolmentForm from './Enrolments/Form.vue';
  export default {
    props: ['is_admin'],
    components: {
      Calendar,
      Students,
      EnrolmentForm,
    },
    data() {
      return {
        timetableId: '',
        timetable: {},
        date: '',
        week: '',
        dialogVisible: false,
        key: 0,
      };
    },
    methods: {
      getTimetable() {
        axios.get(`/timetables-json/${this.timetableId}`)
        .then(res => {
          this.timetable = res.data.data;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      openEnrolmentForm() {
        this.dialogVisible = true;
      },
      onTimetableData (value) {
        this.timetableId = value[0];
        this.getTimetable();
        this.date = value[1];
        this.week = value[2];
      },
      selectCalendarComponent() {
        this.timetableId = '';
        this.date = '';
      },
      onDialogVisible (value) {
        this.key++;
        this.dialogVisible = false;
      }
    },
  };
</script>
